<div class="table">
	<div class="content">
		<div class="icon">
			<img src="assets/logo.svg" alt="">
		</div>
		<h1>404!</h1>
		<h1>Page Not Found!!</h1>
		<p><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{mit}}</a></p>
	</div>
</div>